package com.tovtalk.database.androidui

import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.tovtalk.database.AnalyticsEventsQueueQueries
import com.tovtalk.database.PostQueries
import com.tovtalk.database.TovTalkDatabase
import com.tovtalk.database.UserQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<TovTalkDatabase>.schema: SqlSchema<QueryResult.Value<Unit>>
  get() = TovTalkDatabaseImpl.Schema

internal fun KClass<TovTalkDatabase>.newInstance(driver: SqlDriver): TovTalkDatabase =
    TovTalkDatabaseImpl(driver)

private class TovTalkDatabaseImpl(
  driver: SqlDriver,
) : TransacterImpl(driver),
    TovTalkDatabase {
  override val analyticsEventsQueueQueries: AnalyticsEventsQueueQueries =
      AnalyticsEventsQueueQueries(driver)

  override val postQueries: PostQueries = PostQueries(driver)

  override val userQueries: UserQueries = UserQueries(driver)

  public object Schema : SqlSchema<QueryResult.Value<Unit>> {
    override val version: Long
      get() = 1

    override fun create(driver: SqlDriver): QueryResult.Value<Unit> {
      driver.execute(null, """
          |CREATE TABLE AnalyticsEventQueueEntity (
          |    event_id TEXT PRIMARY KEY NOT NULL,
          |    payload_json TEXT NOT NULL,
          |    created_at INTEGER NOT NULL
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE PostEntity (
          |    id INTEGER PRIMARY KEY NOT NULL,
          |    postType INTEGER NOT NULL,
          |    userId INTEGER NOT NULL,
          |    description TEXT,
          |    hashtags TEXT, -- JSON array as string
          |    
          |    video TEXT,
          |    thumbnail TEXT,
          |    images TEXT, -- JSON array as string
          |    
          |    views INTEGER NOT NULL DEFAULT 0,
          |    likes INTEGER NOT NULL DEFAULT 0,
          |    comments INTEGER NOT NULL DEFAULT 0,
          |    saves INTEGER NOT NULL DEFAULT 0,
          |    shares INTEGER NOT NULL DEFAULT 0,
          |    
          |    isLiked INTEGER NOT NULL DEFAULT 0,
          |    isSaved INTEGER NOT NULL DEFAULT 0,
          |    isPinned INTEGER NOT NULL DEFAULT 0,
          |    canComment INTEGER NOT NULL DEFAULT 1,
          |    isTrending INTEGER NOT NULL DEFAULT 0,
          |    
          |    placeTitle TEXT,
          |    placeLat REAL,
          |    placeLon REAL,
          |    state TEXT,
          |    country TEXT,
          |    
          |    musicId INTEGER,
          |    
          |    createdAt TEXT NOT NULL,
          |    updatedAt TEXT NOT NULL,
          |    
          |    FOREIGN KEY (userId) REFERENCES UserEntity(id) ON DELETE CASCADE
          |)
          """.trimMargin(), 0)
      driver.execute(null, """
          |CREATE TABLE UserEntity (
          |    id INTEGER PRIMARY KEY NOT NULL,
          |    firebaseUid TEXT NOT NULL,
          |    identity TEXT NOT NULL,
          |    fullname TEXT NOT NULL,
          |    username TEXT NOT NULL,
          |    email TEXT,
          |    profilePhoto TEXT,
          |    bio TEXT,
          |    
          |    followerCount INTEGER NOT NULL DEFAULT 0,
          |    followingCount INTEGER NOT NULL DEFAULT 0,
          |    totalPostLikesCount INTEGER NOT NULL DEFAULT 0,
          |    
          |    coinWallet INTEGER NOT NULL DEFAULT 0,
          |    coinCollectedLifetime INTEGER NOT NULL DEFAULT 0,
          |    coinGiftedLifetime INTEGER NOT NULL DEFAULT 0,
          |    coinPurchasedLifetime INTEGER NOT NULL DEFAULT 0,
          |    
          |    isVerified INTEGER NOT NULL DEFAULT 0,
          |    isFreeze INTEGER NOT NULL DEFAULT 0,
          |    isReadOnly INTEGER NOT NULL DEFAULT 0,
          |    isModerator INTEGER NOT NULL DEFAULT 0,
          |    
          |    appLanguage TEXT NOT NULL DEFAULT 'en',
          |    whoCanViewPost INTEGER NOT NULL DEFAULT 0,
          |    showMyFollowing INTEGER NOT NULL DEFAULT 1,
          |    receiveMessage INTEGER NOT NULL DEFAULT 1,
          |    
          |    notifyPostLike INTEGER NOT NULL DEFAULT 1,
          |    notifyPostComment INTEGER NOT NULL DEFAULT 1,
          |    notifyFollow INTEGER NOT NULL DEFAULT 1,
          |    notifyMention INTEGER NOT NULL DEFAULT 1,
          |    notifyGiftReceived INTEGER NOT NULL DEFAULT 1,
          |    notifyChat INTEGER NOT NULL DEFAULT 1,
          |    
          |    country TEXT,
          |    countryCode TEXT,
          |    region TEXT,
          |    city TEXT,
          |    lat REAL,
          |    lon REAL,
          |    
          |    isFollowing INTEGER NOT NULL DEFAULT 0,
          |    followStatus INTEGER NOT NULL DEFAULT 0,
          |    isBlocked INTEGER NOT NULL DEFAULT 0,
          |    
          |    createdAt TEXT NOT NULL,
          |    updatedAt TEXT NOT NULL,
          |    appLastUsedAt TEXT
          |)
          """.trimMargin(), 0)
      driver.execute(null,
          "CREATE INDEX analytics_events_queue_created_at ON AnalyticsEventQueueEntity(created_at)",
          0)
      driver.execute(null, "CREATE INDEX post_type_created ON PostEntity(postType, createdAt)", 0)
      driver.execute(null,
          "CREATE INDEX post_user_type_created ON PostEntity(userId, postType, createdAt)", 0)
      return QueryResult.Unit
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.Value<Unit> = QueryResult.Unit
  }
}
